// test452
(452 && 0);
